import { Collapse, TableCell, TableRow } from '@material-ui/core';
import 'moment/min/locales';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { StyledTableCell, StyledTableCellEditable } from '../../commons/utils/TableStyles.js';
import * as Utils from '../../commons/utils/Utils';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';
const PanolGridRow = ({ columnsEnabled, item, handleEditItem, handleVerHistorico, marcaObligatorio }) => {
  const intl = useIntl();
  const [redirectTo, setRedirectTo] = useState(null);

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      <TableRow>
        {columnsEnabled.external_code && (
          <StyledTableCell align="left">{item.external_code}</StyledTableCell>
        )}
        {columnsEnabled.external_code && (
          <td
            className={(item.activo || item.activo === undefined ? 'status-green' : 'status-red') + ' p-0 all custom-lineHeight br'}
            style={{ maxWidth: '3px' }}
            title={item.activo || item.activo === undefined ? 'Activo' : 'Inactivo'}
          />
        )}
        {columnsEnabled.descripcion && (
          <StyledTableCell align="left">{item.descripcion}</StyledTableCell>
        )}
        {!columnsEnabled.external_code && (
          <td
            className={(item.activo || item.activo === undefined ? 'status-green' : 'status-red') + ' p-0 all custom-lineHeight br'}
            style={{ maxWidth: '3px' }}
            title={item.activo || item.activo === undefined ? 'Activo' : 'Inactivo'}
          />
        )}
        {columnsEnabled.categoria && (
          <StyledTableCell align="left">{item.categoria_eloquent && item.categoria_eloquent.nombre}</StyledTableCell>
        )}
        {columnsEnabled.subcategoria && (
          <StyledTableCell align="left">{item.subcategoria_eloquent && item.subcategoria_eloquent.nombre}</StyledTableCell>
        )}
        {columnsEnabled.unidad && (
          <StyledTableCell align="left">{item.unidad_medida && item.unidad_medida.descripcion}</StyledTableCell>
        )}
        {columnsEnabled.tipo && (
          <StyledTableCell align="left">{item.tipo}</StyledTableCell>
        )}
        {columnsEnabled.numero_parte && (
          <StyledTableCell align="left">{item.numero_parte}</StyledTableCell>
        )}
        {columnsEnabled.referencia && (
          <StyledTableCell align="left">{item.referencia}</StyledTableCell>
        )}
        {columnsEnabled.marca && marcaObligatorio ? (
          <StyledTableCell align="left">{item.marca_eloquent && item.marca_eloquent.nombre}</StyledTableCell>
        ) : null}
        {columnsEnabled.costo && (
          <>
          <StyledTableCell align="left">
            {item.costo ? parseFloat(item.costo).toLocaleString(LocaleFormat.getNumberLocale()) : ''}
          </StyledTableCell>
          <StyledTableCell align="left">
            {item.costo_fijo === 1 || item.costo_fijo === '1' ?
            intl.formatMessage({ id: 'Repuestos.Grid.CostoFijo.Si', defaultMessage: 'Si' })
            : intl.formatMessage({ id: 'Repuestos.Grid.CostoFijo.No', defaultMessage: 'No' })}
          </StyledTableCell>
          <StyledTableCell align="left">
            {item.valor_maximo !== null && item.valor_maximo !== undefined && item.valor_maximo !== ''
              ? parseFloat(item.valor_maximo).toLocaleString(LocaleFormat.getNumberLocale())
              : ''}
          </StyledTableCell>
          </>
        )}
        <StyledTableCell>
          <button
            className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
            data-title="Editar"
            data-toggle="tooltip"
            data-placement="top"
            onClick={handleEditItem}
          >
            <i className="fa fa-pencil fa-xs" />
          </button>
          
          <button
            className="action edit btn btn-sm btn-icon btn-dt-grid text-info"
            data-title="Histórico"
            data-toggle="tooltip"
            data-placement="top"
            onClick={handleVerHistorico}
          >
            <i className="la la-history" style={{ color: "#00c0bd" }} />
          </button>
        </StyledTableCell>
      </TableRow>
    </>
  );
};

export default PanolGridRow;
